// extracted by mini-css-extract-plugin
export default {"CommentListPlaceholder":"ih_a big_jk","CommentListPlaceholder--Legacy":"ih_b big_rc big_wq"};